import { Component, ElementRef, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SpinnerService } from 'src/app/shared/overlay-spinner/service/new-spinner.service';
import { SurveyService } from '../service/survey.service';
import { Ndg } from 'src/app/model/ndg';
import { NdgService } from 'src/app/service/ndg.service';
import { SurveyResponse } from 'src/app/model/survey-response';
import { NdgDataEmit, SurveyNeedsEmit } from 'src/app/model/survey-emits';

@Component({
  selector: 'app-show',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class ShowComponent implements OnInit {
  surveyInfo!: SurveyResponse;

  constructor(
    private route: ActivatedRoute,
    private elementRef: ElementRef,
    private spinnerService: SpinnerService,
    private surveyService: SurveyService,
    private ndgService: NdgService
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe(
      params => {
        let surveyId = params['surveyId'];
        this.spinnerService.showProgress(this.elementRef);

        this.surveyService.getSurveyInfo(surveyId).subscribe({
          next: (res: SurveyResponse) => {
            this.surveyInfo = res;
            this.spinnerService.detach(this.elementRef);
          },
          error: () => {
            this.spinnerService.detach(this.elementRef);
          }
        });
      }
    );
  }

  get ndg(): Ndg | undefined {
    return this.ndgService.activeNdg;
  }

  get surveyNeedsEmit(): SurveyNeedsEmit {
    if(this.ndg?.typology === 'FIS') {
      // FIS typology
      return {
        previdence: this.surveyInfo.needsFis.previdence,
        protection: this.surveyInfo.needsFis.protection,
        savings: this.surveyInfo.needsFis.savings,
        savingsInvestment: this.surveyInfo.needsFis.savingsInvestment,
        savingsPlan: this.surveyInfo.needsFis.savingsPlan
      }
    } else {
      // GIU typology
      const coverageNeeds = this.surveyInfo.needsGiu.coverageNeeds;
      const premium = this.surveyInfo.needsGiu.premium;

      return {
        previdence: false,
        savings: coverageNeeds.includes('A') || coverageNeeds.includes('B'),
        savingsInvestment: premium.includes('A'),
        savingsPlan: premium.includes('B'),
        protection: false
      }
    }
  }

  get ndgDataEmit(): NdgDataEmit {
    return {
      surveyId: this.surveyInfo.surveyId,
      averageIncome: this.surveyInfo.ndgData.averageIncome,
      financialHeritage: this.surveyInfo.ndgData.financialHeritage,
      occupation: this.surveyInfo.ndgData.occupation
    }
  }
}
